import { createUseStyles } from 'react-jss';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { pricingElevation } from '~app/styles/theme';
import { LG_MEDIA_QUERY } from '~shared/media-query';

export default createUseStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  Switch: {
    fontSize: '.875em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: [0, spacing[2]],
    marginTop: 5,
    marginBottom: spacing[5],
    lineHeight: 1.5,
    color: pricingPalette.colors.slate,
    [LG_MEDIA_QUERY]: {
      marginTop: spacing[2],
      marginBottom: 0,
      fontSize: type.fontSize.body,
    },

    '& > *': {
      fontSize: '.875em',
    },

    '& input': {
      opacity: 0,
      width: 0,
      height: 0,
    },
  },
  Values: {
    height: 24,
    width: '100%',
    minWidth: 60,
    maxWidth: 144,
    borderRadius: 50,
    backgroundColor: pricingPalette.colors.pebble,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    position: 'relative',

    '&:before': {
      content: "''",
      display: 'block',
      position: 'absolute',
      width: '50%',
      borderRadius: 50,
      height: '100%',
      backgroundColor: pricingPalette.colors.arctic,
      zIndex: pricingElevation.zero,
      left: 0,
      transition: 'all ease-out .3s',
    },

    '& label': {
      width: '100%',
      minWidth: 30,
      maxWidth: 72,
      textAlign: 'center',
      zIndex: pricingElevation.plusOne,
      transition: 'all ease-out .3s',
      cursor: 'pointer',
      fontWeight: type.fontWeight.medium,

      '&:first-child': {
        color: pricingPalette.colors.white,
      },
    },
  },

  Checked: {
    '&:before': {
      transform: 'translateX(100%)',
    },
    '& label': {
      '&:first-child': {
        color: pricingPalette.colors.slate,
      },
      '&:last-child': {
        color: pricingPalette.colors.white,
      },
    },
  },
}));
